import SearchUrlUpdater from '../../../common/search/SearchUrlUpdater';
import ApiRequestState from '../../../common/search/store/ApiRequestState';
import HouseSearchFilters from './HouseSearchFilters';

export default class SearchUrlUpdaterFactory {
    static readonly #ignoredParams = [
        'place',
        'region',
        'department',
        'country',
        'popular',
        'naturalArea',
        'limit'
    ];

    public static create(): SearchUrlUpdater {
        const filters = HouseSearchFilters.getInstance();
        const updater = new SearchUrlUpdater(ApiRequestState.getInstance(), filters.all);
        updater.setIgnoredParams(SearchUrlUpdaterFactory.#ignoredParams);
        return updater;
    }
}
